// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakpoint":"30rem","form":"style_form__bsP_a","label":"style_label__3gka_"};